// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.brine-panel .content {
  padding: 1.25rem 1.5rem;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
}
.brine-panel .field-label {
  display: block;
  font-size: 0.8rem;
  margin-bottom: 2px;
  color: #424242;
}
.brine-panel .readonly-field {
  background-color: #eeeeee;
  color: #424242;
}
.brine-panel .border-start {
  border-left: 1px solid #e0e0e0;
}
.brine-panel .red-label {
  color: var(--mat-form-field-error-text-color, #f44336);
  font-size: 0.85em;
}
.brine-panel .btn-spinner {
  display: inline-block;
  margin-right: 6px;
  vertical-align: middle;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-details/job-request-details/brine-formulation/brine-formulation.component.scss"],"names":[],"mappings":"AACE;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;AAAJ;AAGE;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AADJ;AAIE;EACE,yBAAA;EACA,cAAA;AAFJ;AAKE;EACE,8BAAA;AAHJ;AAME;EACE,sDAAA;EACA,iBAAA;AAJJ;AAOE;EACE,qBAAA;EACA,iBAAA;EACA,sBAAA;AALJ","sourcesContent":[".brine-panel {\n  .content {\n    padding: 1.25rem 1.5rem;\n    border: 1px solid #dcdcdc;\n    border-radius: 8px;\n  }\n\n  .field-label {\n    display: block;\n    font-size: 0.8rem;\n    margin-bottom: 2px;\n    color: #424242;\n  }\n\n  .readonly-field {\n    background-color: #eeeeee;\n    color: #424242;\n  }\n\n  .border-start {\n    border-left: 1px solid #e0e0e0;\n  }\n\n  .red-label {\n    color: var(--mat-form-field-error-text-color, #f44336);\n    font-size: 0.85em;\n  }\n\n  .btn-spinner {\n    display: inline-block;\n    margin-right: 6px;\n    vertical-align: middle;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
